import { BubbleMenu, Editor, EditorContent } from "@tiptap/react";
import { cn } from "~/lib/utils";
import { Button } from "../ui/button";

interface IProps {
  isLoading?: boolean;
  editor: Editor | null;
  className?: string;
}

const EditorComponent = ({ editor, className, isLoading }: IProps) => {
  if (!editor) return null;

  return (
    <>
      <BubbleMenu editor={editor}>
        <div className="flex space-x-1 items-center bg-background border p-1 rounded-lg">
          <Button
            size={"sm"}
            variant={editor.isActive("bold") ? "secondary" : "ghost"}
            onClick={() => editor.chain().focus().toggleBold().run()}
            className={editor.isActive("bold") ? "is-active" : ""}
          >
            <strong>B</strong>
          </Button>
          <Button
            size={"sm"}
            variant={editor.isActive("italic") ? "secondary" : "ghost"}
            onClick={() => editor.chain().focus().toggleItalic().run()}
            className={editor.isActive("italic") ? "is-active" : ""}
          >
            <em>I</em>
          </Button>
          <Button
            size={"sm"}
            variant={editor.isActive("strike") ? "secondary" : "ghost"}
            onClick={() => editor.chain().focus().toggleStrike().run()}
            className={editor.isActive("strike") ? "is-active" : ""}
          >
            <s>S</s>
          </Button>
        </div>
      </BubbleMenu>
      <EditorContent
        className={cn(
          "prose max-w-none overflow-y-scroll prose-p:m-0 focus:outline-none",
          className
        )}
        disabled={isLoading}
        editor={editor}
      />
    </>
  );
};

export default EditorComponent;
